<template>
  <div>
    <!-- 年度开工率 -->
    <Echart
      :options="options"
      id="bottomLeftChart"
      height="480px"
      width="100%"
    ></Echart>
  </div>
</template>

<script>
import Echart from '@/common/echart'
export default {
  data () {
    return {
      options: {},
    };
  },
  components: {
    Echart,
  },
  props: {
    cdata: {
      type: Object,
      default: () => ({})
    },
  },
  watch: {
    cdata: {
      handler (newData) {
        
        this.options = {
          tooltip: {
            trigger: "axis",
            backgroundColor: "rgba(255,255,255,0.1)",
            axisPointer: {
              type: "shadow",
              label: {
                show: true,
                backgroundColor: "#7B7DDC"
              }
            }
          },
          legend: {
            data: ["光照强度(LUX)", "环境温度(℃)", "环境湿度(%)"],
            textStyle: {
              color: "#B4B4B4",
              fontSize:"17",
            },
            top: "0%",
            icon: 'roundRect',
          },
          grid: {
            x: "8%",
            width: "88%",
            y: "4%"
          },
          // xAxis: {
          //   data: newData.times,
          //   axisLine: {
          //     lineStyle: {
          //       color: "#B4B4B4"
          //     }
          //   },
          //   axisTick: {
          //     show: false
          //   }
          // },
          xAxis: {
              //name:'时间',
              type: 'category',
              boundaryGap: false,
              data: newData.times,
            },
          // yAxis: [
          //   {
          //     splitLine: { show: false },
          //     axisLine: {
          //       lineStyle: {
          //         color: "#B4B4B4"
          //       }
          //     },

          //     axisLabel: {
          //       formatter: "{value} "
          //     }
          //   },
          //   {
          //     // name:'光照强度',
          //     splitLine: { show: false },
          //     axisLine: {
          //       lineStyle: {
          //         color: "#B4B4B4"
          //       }
          //     },
          //     axisLabel: {
          //       formatter: "{value} "
          //     }
          //   }
          // ],
          yAxis: {
              type: 'value',
              splitLine: {
                show: true,
                lineStyle: {
                  color: '#fff',
                  opacity: 0.1
                }
              }
            },
          series: [
            {
              name: "光照强度(LUX)",
              type: "line",
              // smooth: true,
              // showAllSymbol: true,
              // symbol: "emptyCircle",
              // symbolSize: 8,
              // yAxisIndex: 1,
              itemStyle: {
                normal: {
                  color: "#F02FC2"
                }
              },
              lineStyle: {
                width:3,
              },
              data: newData.brightData
            },
            {
              name: "环境温度(℃)",
              // type: "bar",
              // barWidth: 5,
              type: "line",
              // smooth: true,
              itemStyle: {
                normal: {
                  // barBorderRadius: 5,
                  color: "#3EACE5",
                  // color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  //   { offset: 0, color: "#956FD4" },
                  //   { offset: 1, color: "#3EACE5" }
                  // ])
                }
              },
              lineStyle: {
                width:3,
              },
              data: newData.tempData
            },
            {
              name: "环境湿度(%)",
              // type: "bar",
              // barWidth: 10,
              // barGap: "-100%",
              type: "line",
              // smooth: true,
              itemStyle: {
                normal: {
                  // barBorderRadius: 5,
                  // color: "#3e1d62",
                  color: "#9c6bd3",
                  // color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  //   { offset: 0, color: "rgba(156,107,211,0.8)" },
                  //   { offset: 0.2, color: "rgba(156,107,211,0.5)" },
                  //   { offset: 1, color: "rgba(156,107,211,0.2)" }
                  // ])
                }
              },
              lineStyle: {
                width:3,
              },
              // z: -12,
              data: newData.humidityData
            }
          ]
        }
      },
      immediate: true,
      deep: true
    },
  },
}
</script>